module.exports = __webpack_public_path__ + "static/2-2560ea53aef2677e44ed2086991bfaea.jpg";